"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Blockchain = void 0;
exports.Blockchain = {
    name: "blockChain",
    async info() {
        // @ts-ignore
        return await this.call("blockchain.info");
    },
    async block() {
        // @ts-ignore
        return this.call("blockchain.block", {});
    },
    async transaction() {
        // @ts-ignore
        return await this.call("blockchain.transaction", new Map([[1, symbols]]));
    },
};
